/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {useTranslation} from "react-i18next";
import {FieldErrors} from "react-hook-form/dist/types/errors";

const BookingLoginErrors = (props: {errors: FieldErrors<{email: string}>}) => {
    const {t} = useTranslation();
    return (
        <div className={"BookingLoginErrors flex flex-col justify-center items-center gap-y-4"}>
            {Object.keys(props.errors).length !== 0 && (
                <div className={"text-center text-sm text-arbo-red mt-4 px-4 py-2 font-regular"}>
                    {Object.keys(props.errors).map((errorKey, index) => {
                        return (
                            <p key={index} className={""}>
                                {t(props.errors[errorKey]?.message)}
                            </p>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default BookingLoginErrors;
